import React from 'react';

import { NavigationStore } from 'framework/navigationStore';
import Settings from 'settings';
import { ModalPosition, openModal } from 'controls/react/ant/antModal';
import { ApplicationState } from 'framework/applicationState';

export type RedirectPopup = {
	width: number;
	height: number;
	position: ModalPosition;
	scaleContent?: boolean;
};

export enum RedirectModifier {
	None,
	NewTab,
	Popup,
}

export type NavigatorGoArgs = {
	action?: (modifier: RedirectModifier, popup: RedirectPopup) => void;
	url?: string;
	modifier?: RedirectModifier;
	popup?: RedirectPopup;
};

export const PROTOCOL_REGEX = new RegExp('^\\w+://', 'i');

export class CeeviewNavigator {
	get forceEnabled() {
		return ApplicationState.standalone && ApplicationState.isGuestUser;
	}

	go(props: NavigatorGoArgs) {
		if (props.action) {
			props.action(props.modifier, props.popup);
			return;
		}

		if (props.modifier == RedirectModifier.NewTab || props.modifier == RedirectModifier.Popup) {
			let url = props.url;

			if (!PROTOCOL_REGEX.test(url)) {
				if (!url.startsWith('#')) {
					url = '#' + url;
				}

				url = Settings.httpRoot + url;
			}

			if (props.modifier == RedirectModifier.Popup) {
				openModal(
					{
						title: ' ',
						footer: null,
						positionType: props.popup.position,
						width: props.popup.width,
						height: props.popup.height,
					},
					<iframe src={url} style={{ width: '100%', height: '100%' }} />,
				);
			} else {
				window.open(url, '_blank');
			}
		} else {
			if (PROTOCOL_REGEX.test(props.url)) {
				location.assign(props.url);
			} else {
				NavigationStore.go(props.url);
			}
		}
	}

	renderLink(link: string) {
		return `href="#${link}"`;
	}

	canDoDefault() {
		return true;
	}
}
